import { Component, OnInit } from '@angular/core';
import {ResourceHelper} from "../../lib/util/http-services";

@Component({
  selector: 'app-colonnade-online-success',
  templateUrl: './colonnade-online-success.component.html',
  styleUrls: ['./colonnade-online-success.component.scss']
})
export class ColonnadeOnlineSuccessComponent implements OnInit {

  constructor(private resourceHelper: ResourceHelper) { }

  ngOnInit(): void {
  }

  get successLogo(): string | undefined {
    return this.resourceHelper.getHelpdeskLogoSuccessSrc();
  }

}
